import { FormLoadingIndicator } from 'components/shared/FormLoadingIndicator/FormLoadingIndicator';
import { useAppSelector } from 'hooks/useAppSelector';
import { PropsWithChildren } from 'react';
import { WorkspaceType } from 'state/workspaces/model';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

type Props = PropsWithChildren<{
  workspace: WorkspaceType;
}>;
export function ActiveTabGuard({ workspace, children }: Props) {
  const activeTabId = useAppSelector(state => getWorkspaceActiveTabId(state, workspace));

  if (!activeTabId) {
    return <FormLoadingIndicator className="w-100 justify-content-center align-items-center mt-0 h-100" />;
  }
  return children;
}
